/**
 * @fileoverview A hook that provides functions to open and close a toast.
 *
 * @example
 * const [openToast, closeToast] = useToast();
 * openToast({ title: 'My Toast', content: 'This is the content of my toast' });
 * closeToast();
 */

import { useContext } from 'react'
import { ToastConfig, ToastContext } from '../components/toasts/ToastContext'

/**
 * @function useToast
 * @description Hook to open and close a toast.
 * @returns {[(toastConfig: ToastConfig) => void, () => void]} - Functions to open and close the toast.
 */
export function useToast(): [(toastConfig: ToastConfig) => void, () => void] {
    const toast = useContext(ToastContext)
    return [toast.open, toast.close]
}
